export enum DrillDownType {
    matterSummary = 1,
    leadSummary = 2,
    matterManagementSummary = 3,
    taskSummary = 4,
    referrer = 5,
    nameSummary = 6,
    matterSummaryDrilldown = 7,
    mailingParty = 8,
    timesheetSummary = 9,
    invoiceSummary = 10,
    staffSummary = 11,
    staffBillingSummary = 12,
    notesSummary = 13,
    writeOnOffSummaryDrilldown = 14,
    unbilledFeeEarnerDrilldown = 15,
}